import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var OwlfonsoContainer = require('components/utility/OwlfonsoContainer');
var Spinner = require("components/utility/Spinner");
var StudentAvatar = require("components/avatars/StudentAvatar");
var CurrentUser = require("lib/account/CurrentUser");
var StepProgressMeter = require("components/utility/StepProgressMeter");
var LoadingButton = require("components/utility/LoadingButton");

var AutograderFeedback = require("lib/web/AutograderFeedback");
var BookRating = require("components/reading/books/BookRating");
var QuestionFeedback = require("components/writing/questions/QuestionFeedback");
var FeedbackFormatter = require("lib/interface/FeedbackFormatter");
var Spinner = require("components/utility/Spinner");
var Autosaver = require("components/writing/quizzes/Autosaver");
//for connecting////////////
var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var WritingActions = require("lib/actions/WritingActions");
var WritingSelectors = require("lib/selectors/WritingSelectors");
///////////////////////////////
var MyShelfRouting = require("lib/routing/MyShelfRouting");
var ArbitrarySubjects = require("lib/data/ArbitrarySubjects");
require("writing/answers/question_builder_page.scss")


function getPartIndexes(parts, part_type) {
	var targetIndex = -1
	_.some(parts, (part, i) => {
		if (part["type"] == part_type) {
			targetIndex = i
			return true
		}
	});
	return targetIndex
}

@connect(
	(state, props) => {
		var textID = $wr.getURLParameterByName("text_id");
		var answerID = $wr.getURLParameterByName("answer_id");
		var userID = CurrentUser.get().id

		var book = ReadingSelectors.book({ state, id: textID });

		var downProps = { book };

		if (!(WritingSelectors.isLoadingQuestions({ state }) ||
			  WritingSelectors.isLoadingAnswers({ state, key: "index" }) ||
			  WritingSelectors.isLoadingAnswers({ state, key: "create" }))) {

			if (downProps.book) {
				var conditions = {
					textID: textID,
				}

				downProps.metaQuestion = WritingSelectors.mostRecentQuestions({
					state,
					filters: {
						type: "meta-cognitive-question",
						key: "fill-in-the-blank"
					}
				});
				if (answerID) {
					downProps.questionBuilder = WritingSelectors.answer({
						state, id: answerID
					});
				} else if (downProps.metaQuestion) {
					downProps.questionBuilder = WritingSelectors.answers({
						state,
						filters: {
							text_id: textID,
							question_id: downProps.metaQuestion.id
						}
					}).filter(x => x.draft || x.allow_revision)[0];
				}
			}
		}
		downProps.currentStage = SENTENCE_INPUT_STAGE
		return downProps;
	},
	(dispatch, props) => {
		var userID = CurrentUser.get().id
		var textID = $wr.getURLParameterByName("text_id");

		function fetchBook() {
			
			return dispatch(ReadingActions.fetchBookSynchronously({ id: textID, userID: userID })).then((response) => {
				var book = _.first(response.books);
				if (book) {
					fetchMetaCognitiveQuestion();
				} else { 
					console.log("No book matching text ID found.")
				}
			});
		}

		function fetchDraft(questionID) {
			dispatch(WritingActions.fetchAnswers({
				filters: {
					question_id: questionID
				},
				conditions: {
					textID,
					draftOnly: true
				},
				embeds: ["answer.question", "answer.meta_data", "answer.history"]
			})).then((response) => {
				if (_.isEmpty(response.answers)) {
					createMetaCognitiveAnswer(questionID);
				}
			});
		}

		function fetchMetaCognitiveQuestion() {
			var filters = {
				types: "meta-cognitive-question",
				key: "fill-in-the-blank"
			}
			dispatch(WritingActions.fetchQuestions({ filters })).then((response) => {
				var question = _.first(response.questions);
				if (question) {
					fetchDraft(question.id);
				} else {
					console.log("No question found!")
				}
			});
		}

		function createMetaCognitiveAnswer(questionID) {
			var answerData =  {
				draft: true, text_id: textID,
				question_id: questionID,
			}
			dispatch(ReadingActions.invalidateBookCache({}));
			return dispatch(WritingActions.createAnswer({ answer: answerData }));
		}

		function updateMetaCognitiveAnswer(answerID, answerData) {
			dispatch(ReadingActions.invalidateBookCache({}));
			return dispatch(WritingActions.updateAnswer({
				id: answerID,
				update: answerData
			}));
		}

		function deleteMetaCognitiveAnswer(answerID) {
				var update = {"activity:any:any": null};
				dispatch(ReadingActions.localUpdateBook({id: textID, update}));
				dispatch(ReadingActions.invalidateBookCache({}));
				return dispatch(WritingActions.deleteAnswer({ id: answerID }))
		}

		function postShortAnswerGrade(params) {
			params['subjectType'] = ArbitrarySubjects.ANSWER
			return dispatch(WritingActions.postWritingGrade(params))
		}

		return {
			populateData: fetchBook,
			fetchMetaCognitiveQuestion: fetchMetaCognitiveQuestion,
			createMetaCognitiveAnswer: createMetaCognitiveAnswer,
			updateMetaCognitiveAnswer: updateMetaCognitiveAnswer,
			deleteMetaCognitiveAnswer: deleteMetaCognitiveAnswer,
			postShortAnswerGrade: postShortAnswerGrade
		}
	}
)

@providePopulateData({waitForLoad:true})
class QuestionBuilderPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		//don't understand this part in NWP need replicate for new component?
		LuckyOrangeClient.tagComponent("QuestionBuilderPage");

		// INIT SELECTD BLANKS
		this.state = {
			//Klim fitb pages iteration
			currentStage: props.currentStage,
			loading: false,
			//Owlfonso show
			feedbackShow: false,		/// what is this
			//question Builder answer data button index holders for button highlighting display in step 2
			selectedBlanks: {},
			synonyms: {},
			//autograder
			recentAutograderData: null,
			//end
			finish: false,				/// what is this
			unsavedSynonyms: false /// tracks if user didn't add a synonym
		}
	}

	/****************************** PAGE TEXT ******************************************/

	//Error Handling
	errorText(errorID) {
		var errorArray = {
			"questionShort": "In order for me to help you write the very best answer you can, I will need you to write a bit more first. Click 'Check again!' when you are ready",
			"noQuestion": "Please write at least a short response to this question.",
			"answerShort": "In order for me to help you write the very best answer you can, I will need you to write a bit more first. Click 'add' again when you are ready",
			"answerLong": "In order for me to help you write the very best answer you can, I will need you to write a maximum of three words. Click 'add' again when you are ready",
			"consecutiveWords": "Words must be next to each other to form one blank.",
			"threeWordLimit": "Please choose up to 3 words for your blank.",
			"repeatingAnswer": "Please make sure the answer you have written isn't the same as a previous answer."
		}
		return (errorArray[errorID]);
	}
	//Page text
	pageText(pageTextID) {
		var gradeLevel = CurrentUser.get().prefs.academic_level;
		var textTitle = this.props.book.title;
		if (gradeLevel > 3) {
			var owlMessage = "Write a complete sentence about a detail or event in "+textTitle+". Your sentence should be a statement, not a question, and should include a text detail you learned while reading the text.";
		} else {
			var owlMessage = "Write a sentence about "+textTitle+". Your sentence should be about something you learned while reading the book.";
		}
		var pageTextArray = {
			"textSelectBlank": "Select a word or phrase (up to three words) to be blanked out and become the answer. Be sure to choose a blank that someone who read the book would know, but someone who did not read the book could not easily guess.\n\n*Example:*\nThe Once-ler cut down a ____ tree and used it to knit a Thneed.",
			"initialText": owlMessage,
			"addSynonymsMessage": "Sometimes blanks can have more than one right answer. Read your sentence again and think about other words that would also be correct answers for your blank.",
			"submitQuestionBuilder": "You have provided 3 answer options, submit your Question Builder to recieve your coins!",
			"submitPopUp": "You have completed your Question Builder!",
			"selectBlankPopUp": "You have chosen where the blank belongs.",
			"sentenceWritePopUp": "You wrote a sentence. That's step one!"
		}
		return (pageTextArray[pageTextID]);
	}

	/****************************** OWLFONSO FEEDBACK ***************************************/

	// Check to see if a particular filter was detected.
	hasFilter(filter, autograderData) {
		if (autograderData && autograderData.filtering) {
			var filters = _.keys(autograderData.filtering);
			return filters.includes(filter);
		} else {
			return false;
		}
	}

	isLoading() {
		return this.props.loading || this.state.feedbackLoading;
	}

	currentAutograderData() {
		return this.state.recentAutograderData;
	}

	showFeedback() {
		return _.any(this.feedbackItems()) && !this.isLoading();
	}

	feedbackSubs() {
		var autograderData = this.currentAutograderData();
		if (autograderData && autograderData.feedback_subs) {
			return autograderData.feedback_subs;
		}		
	}

	feedbackItems() {
		var autograderData = this.currentAutograderData();
		if (autograderData && autograderData.assisting) {
			var firstElegibleKeys = _.keys(autograderData.assisting.selected_content)
			if (firstElegibleKeys.length > 0) {
				var selectedKey = firstElegibleKeys.sort()[0]
				return autograderData.assisting.selected_content[selectedKey].content || autograderData.assisting.selected_content[selectedKey]
			}
			return null;
		}
	}

	shouldRewardShow() {
		return (false);
		var autograderData = this.currentAutograderData();

		if (!autograderData) {
			return false;
		}

		// Check if answer is too short
		if (this.hasFilter("REQUIREMENT-MINIMUM_LENGTH", autograderData)) {
			return false;
		}

		// Check if max amount of reward hasn't been exceeded
		var checkString = "addressed-feedback-" + this.props.questionIndex;
		var count = this.props.coinHistory.reduce((n, val) => {
			return n + (val === checkString);
		}, 0);

		return count < 2;
	}

	renderFeedback() {
		if (this.showFeedback()) {
			var subs = this.feedbackSubs();
			if (typeof this.feedbackItems() === "string") {
				var feedbackItemsArr = [this.feedbackItems()]
			} else if (Array.isArray(this.feedbackItems())) {
				var feedbackItemsArr = this.feedbackItems()
			} else {
				var feedbackItemsArr = []
			}
			var renderedItems = _.map(feedbackItemsArr, (item) => {
				return FeedbackFormatter.format(item, subs);
			})
			return (
				<QuestionFeedback feedbackItems={ renderedItems } 
					showFeedbackReward={ this.shouldRewardShow() } />
			);			
		}
	}

	/******************************* questionBuilder Helpers ***********************************/

	getPartItemText(part_type) {
		if (this.props.questionBuilder) {
			var index = getPartIndexes(this.props.questionBuilder.parts, part_type)
			if (index > -1 ) {
				return this.props.questionBuilder.parts[index].text
			}
		}
	
		return "";
	}

	areConsecutive(selectedBlanks, questionWords) {
		// BLANKS SHOULD BE CONSECUTIVE
		var consecutiveKeys = true
		var lastIndex = null

		_.each(_.keys(selectedBlanks), (key) => {
			var k = parseInt(key)
			var acceptableBeforeIndex = k - 1
			// adjust acceptable before index if there is excluded pubncutation involved
			for (var i = acceptableBeforeIndex; i > 0; i--) {
				if (!_.include(EXCLUDED_PUNCTUATION, questionWords[i])) {
					acceptableBeforeIndex = i
					break;
				}
			}
			// return false if last index is not the acceptable before index
			if (lastIndex != null && lastIndex != acceptableBeforeIndex) {
				consecutiveKeys = false
				return false
			}
			
			lastIndex = k
		})
		return consecutiveKeys;
	}


	getQuestionBuilderAnswers() {
		return _.values(this.state.synonyms);
	}

	updateQuestionParts(text, part_type, index) {
		var parts = this.props.questionBuilder.parts
		if (parts == null) {
			parts = []
		}
		var targetIndex = getPartIndexes(parts, part_type)
		if (targetIndex == -1) {
			parts.push({ text: text, type: part_type, index: index })
		} else {
			parts[targetIndex]["text"] = text
			parts[targetIndex]["index"] = index
		}
		return parts
	}

	updateQuestionAnswer(text) {
		var parts = this.props.questionBuilder.parts
		var targetIndex = getPartIndexes(parts, "answer")

		if (targetIndex == -1) {
			parts.push({ text: text, type: "answer" })
		} else {
			parts[targetIndex]["text"] = text
		}
		this.props.updateMetaCognitiveAnswer(
			this.props.questionBuilder.id,
			{ parts: parts }
		);
	}

	updateQuestionSynonym(body) {
		var parts = this.props.questionBuilder.parts
		
	}

	updateQuestionBuilder(question, ansArr) {
		var qs = question;
		if (!ansArr[0] && question.includes("____")) {
			qs = question.replace("____", this.props.questionBuilder.parts[1].text);
		} else if (ansArr[0] && !question.includes("____")) {
			qs = question.replace(ansArr[0], "____");
		}
		var answerData = {
			parts: [
				{ text: qs, type: "body" },
				{ text: (ansArr[0] ? ansArr[0] : ""), type: "answer" },
				{ text: (ansArr[1] ? ansArr[1] : ""), type: "answer" },
				{ text: (ansArr[2] ? ansArr[2] : ""), type: "answer" },
				{ text: (ansArr[3] ? ansArr[3] : ""), type: "answer" },
				{ text: (ansArr[4] ? ansArr[4] : ""), type: "answer" }
			]
		};
		this.props.updateMetaCognitiveAnswer(
			this.props.questionBuilder.id,
			answerData
		);
	}

	/************************************ STEP 1 *********************************************/

	handleExcludedPunctuation(answerString, command) {
		var loopCount = 0
		var returnString = _.clone(answerString)
		_.each(EXCLUDED_PUNCTUATION, (punct) => {
			loopCount += 1
			if (command === 'add-spaces') {
				returnString = _.include(NO_PRECEDING_SPACE, punct) ? returnString.replaceAll(punct, ' ' + punct) : returnString.replaceAll(punct, punct + ' ')
			} else if (command === 'remove-spaces') {
				returnString = _.include(NO_PRECEDING_SPACE, punct) ? returnString.replaceAll(' ' + punct, punct) : returnString.replaceAll(punct + ' ', punct)
			}
		})
		if (loopCount === _.size(EXCLUDED_PUNCTUATION)) {
			return returnString
		}
	}
	gotoBlankOut() {
		var question = this.refs.question.value;


		this.props.updateMetaCognitiveAnswer(
			this.props.questionBuilder.id,
			{ parts: this.getLatestParts() }
		);

		// EXTRACTING SELECTED BLANKS
		var selectedBlanks = {}
		var answerIndex = getPartIndexes(this.props.questionBuilder.parts, "answer")
		if (answerIndex > -1) {
			var answerPart = this.props.questionBuilder.parts[answerIndex]
			_.each(this.handleExcludedPunctuation(answerPart.text, 'add-spaces').split(/\s+/), (word, i) => {
				selectedBlanks[parseInt(answerPart.index) + i] = word
			})
		}
		this.setState({
			currentStage: BLANK_SELECTION_STAGE,
			loading: false,
			feedbackShow: true,
			selectedBlanks: selectedBlanks,
			recentAutograderData: { 
				assisting: { selected_content: {1: {content:[this.pageText("textSelectBlank")]}} }
			}
		});

		window.wrNotifications.triggerDropDownNotification({
			title: "Excellent!", text: this.pageText("sentenceWritePopUp") , icon: "star" });
	}

	// Asking students for a good question
	handleFitbButtons() {
		// some conditions to make sure question follows the right syntax:
		// grammar, wording, phrasing, etc.
		// print red banner if conditions arent met
		var question = this.refs.question.value;

		if (!question) {
			window.wrNotifications.triggerDropDownNotification({
				title: "We need a bit more!", icon: "pencil", text: this.errorText("noQuestion") });
		} else if (question.split(' ').length < 5) {
			//update database
			this.setState({
				feedbackShow: true,
				recentAutograderData: { 
					assisting: { selected_content: {1: {content:[this.errorText("questionShort")]}} }
				} 
			})
		} else {
			this.setState({ loading: true });
			//add grade level of student
			var answerData = {
				answer: question,
				question: "",
				text: { title: this.props.book.title, text_variety: this.props.book.text_variety }
			}

			this.props.postShortAnswerGrade(
				AutograderFeedback.formatQuestionBuilderRequest(answerData)
			).then((response) => {
				console.log(response)
				AutograderFeedback.formatQuestionBuilderResults(response, answerData, (result) => {
					if (result && result.autograderData) {
						this.setState((state) => {
							return {
								recentAutograderData: result.autograderData,
								feedbackShow: true,
								loading: false,
							}
						});
						if (result.noFeedback) {
							this.gotoBlankOut();
						}
					}
				})
			})
		}
	}

	renderButtonsQuestionDisplay() {
		if (!this.state.feedbackShow) {
			var submit = (
				<LoadingButton
					className="btn buttonPrimary buttonPrimaryRight"
					text="Next"
					onClick={ this.handleFitbButtons.bind(this) }
					loading={ this.state.loading } />
			);
		} else {
			var submit = (
				<LoadingButton
					className="btn buttonDefault buttonPrimaryRight submitAnyway"
					text="Skip"
					onClick={ this.gotoBlankOut.bind(this) }
					loading={ this.state.loading } />
			);
			var tryAgain = (
				<LoadingButton
					className="btn buttonPrimary buttonPrimaryRight"
					text="Check Again"
					onClick={ this.handleFitbButtons.bind(this) }
					loading={ this.state.loading } />
			);
		}
		return (
			<div className="buttonsBox">
				{ tryAgain }
				{ submit }
			</div>
		);
	}

	renderQuestionDisplay() {
		//Owlfonso feedback
		if (!this.state.recentAutograderData) {
			this.setState({
				recentAutograderData: {
					assisting: { selected_content: {1: {content: [this.pageText("initialText")]}} }
				}
			})
		}
		var questionText = this.getPartItemText("question")

		return (
			<div>
				<div className="questionDisplayBox slideLeft">
					<h3>Write a Sentence</h3>
					<textarea
						ref="question"
						className="form-control"
						placeholder={ "Write a sentence about your text." }
						defaultValue={ questionText }
					/>
					<b className="exampleStylingWriteSentence">Example:</b>
					<p className="textStylingWriteSentence">The Once-ler cut down a Truffula tree and used it to knit a Thneed.</p>
					{ this.renderButtonsQuestionDisplay() }
				</div>
				<div className="questionFeedbackBox">
					{ this.renderFeedback() }
				</div>
			</div>
		);
	}

	/**************************************** STEP 2 *********************************************/
	//	Asking student to select blank
	goBackToWriteASentence() {
		this.props.updateMetaCognitiveAnswer(
			this.props.questionBuilder.id,
			{ parts: this.getLatestParts() }
		);
		this.setState((state) => {
			return {
				currentStage: SENTENCE_INPUT_STAGE,
				feedbackShow: false,
				recentAutograderData: {
					assisting: { selected_content: {1: {content:[this.pageText("initialText")]}} }
				}
			}
		});
	}

	goNextToSubmit() {
		if (_.size(this.state.selectedBlanks) == 0) {
			window.wrNotifications.triggerDropDownNotification(
			{
				type: "error",
				title: "Select Answer!",
				text: "Don't forget to press which word you want to blank out!", 
				icon: "remove"
			});
		} else {

			this.props.updateMetaCognitiveAnswer(
				this.props.questionBuilder.id,
				{ parts: this.getLatestParts() }
			);

			// EXTRACT SYNONYMS
			var synonyms = {}
			_.each(this.props.questionBuilder.parts, (part) => {
				if (part.type.includes("synonym")) {
					synonyms[part.index] = part.text
				}
			})
			

			this.setState({
				recentAutograderData: { 
					assisting: { selected_content: {1: {content: [this.pageText("addSynonymsMessage")]}} }
				},
				currentStage: SYNONYM_INPUT_STAGE,
				synonyms
			})
			window.wrNotifications.triggerDropDownNotification({
					title: "Great Work!", text: this.pageText("selectBlankPopUp") , icon: "star" });
		}
	}

	getRightOrderAnswer(questionWords, arrActiveAnswer) {

		var answer = "";
		for (var i = 0; i < arrActiveAnswer.length; i++) {
			if (arrActiveAnswer[i] === ACTIVE_BTN) {
				answer = answer + (answer ? " " : "") + questionWords[i];
			}
		}
		//handle punctuation
		if (answer.charAt(answer.length - 1) === "."||
			answer.charAt(answer.length - 1) === "!" ||
			answer.charAt(answer.length - 1) === "?") {
			//delete the last character of your answer if you find a dot
			return ([answer.slice(0, -1)]);
		}
		return ([answer]);
	}

	cleanOutBlankQuestion(questionWords, arrActiveAnswer) {

		var addWords = "";
		var underScoreMarker = 0;
		
		for (var i = 0; i < arrActiveAnswer.length; i++) {
			if (arrActiveAnswer[i] === INACTIVE_BTN) {
				addWords = (i === 0) ? questionWords[i] : addWords + " " + questionWords[i];
			} else if (arrActiveAnswer[i] === ACTIVE_BTN && underScoreMarker == 0) {
				addWords = (i === 0) ? "____" : addWords + " " + "____";
				underScoreMarker = 1;
			}
		}
		//handle punctuation
		if (arrActiveAnswer[arrActiveAnswer.length - 1] === ACTIVE_BTN) {
			//add a dot to your question with blank if your last word was a blank
			var str = questionWords[questionWords.length-1];
			addWords = addWords + str.charAt(str.length-1);
		}
		return (addWords);
	}

	clickBlankStoreAnswer(blank, index, questionWords) {

		var selectedBlanks = _.clone(this.state.selectedBlanks)
		if (index in selectedBlanks) {
			// MUST BE BEGINING OR ENDING BLANK
			if (index != 0 && index != _.size(_.keys(selectedBlanks)) - 1) {
				window.wrNotifications.triggerDropDownNotification(
					{
						type: "error",
						title: "Consecutive Words",
						text: this.errorText("consecutiveWords"),
						icon: "remove"
					});
			} else {
				delete selectedBlanks[index]
				this.setState({ selectedBlanks });
			}
		} else {

			selectedBlanks[index] = blank

			// SHOULD SELECT 1 TO 3 BLANKS
			if (_.size(selectedBlanks) > 3) {
				window.wrNotifications.triggerDropDownNotification(
				{
					type: "error",
					title: "Try Again!",
					text: this.errorText("threeWordLimit"),
					icon: "remove"
				});
			} else {
				// BLANKS SHOULD BE CONSECUTIVE
				var consecutive = this.areConsecutive(selectedBlanks, questionWords);
				if (!consecutive) {
					window.wrNotifications.triggerDropDownNotification(
					{
						type: "error",
						title: "Consecutive Words",
						text: this.errorText("consecutiveWords"), 
						icon: "remove"
					});
				} else {
					this.setState({ selectedBlanks }); 
				}
			}
		}
	}

	makeBlankButton(blank, index, questionWords) {
		if (!EXCLUDED_PUNCTUATION.includes(blank)) {
			//swap button style arround to deselect the button the student selected
			var buttonStyleOnOff = "btn buttonDefault"
			if (this.state.selectedBlanks && index in this.state.selectedBlanks)
				buttonStyleOnOff = "btn buttonPrimary"
			return (
				<button
					className={buttonStyleOnOff}
					onClick={() => this.clickBlankStoreAnswer(blank, index, questionWords)} >
					{blank}
				</button>
			);
		} else {
			//render punctuation as disabled button
			return (
				<button
					disabled={true}
					className='btn buttonNonClickable'>
					{blank}
				</button>
			)
		}
	}

	getQuestionWithBlank() {
		const question = this.getPartItemText("question")
		return this.handleExcludedPunctuation(_.map(this.handleExcludedPunctuation(question, 'add-spaces').split(/\s+/), (word, i) => {
			return i in this.state.selectedBlanks ? "_" : word
		}).join(" ").replaceAll("_", " ____ "), 'remove-spaces')
	}

	renderAnswerBlank() {
		//check question and question with blank
		var question = this.getPartItemText("question");
		
		var questionWords = this.handleExcludedPunctuation(question, 'add-spaces').split(/\s+/);
		var feedbackDisplay = (
			<div className="questionFeedbackBox">
				{ this.renderFeedback() }
			</div>
		);

		if (_.size(this.state.selectedBlanks) > 0) {
			var questionWithBlank = this.getQuestionWithBlank()
			var answer = this.handleExcludedPunctuation(_.values(this.state.selectedBlanks).join(" "), 'remove-spaces')
			var blankDisplay = (
				<div className="blankDisplay">
					<b className="questionStylingSelectBlank">Question:</b>
					<p className="textStylingSelectBlank">{ questionWithBlank }</p>
					<b className="questionStylingSelectBlank">Answer:</b>
					<p className="textStylingSelectBlank">{ answer }</p>
				</div>
			)
		}

		return (
			<div>
				<div className="questionDisplayBox slideLeft">
					<h3>Select the Blank</h3>
					{ questionWords.map((blank, index) => this.makeBlankButton(blank, index, questionWords)) }
					<br />
					{ blankDisplay }
					<div className="buttonsBox">
						<LoadingButton
							className="btn buttonPrimary buttonPrimaryLeft"
							text="Back"
							onClick={ this.goBackToWriteASentence.bind(this) }
						/>
						<LoadingButton
							className="btn buttonPrimary buttonPrimaryRight"
							text="Next"
							onClick={ this.goNextToSubmit.bind(this) }
						/>
					</div>
				</div>
				{ feedbackDisplay }
			</div>
		);
	}

	/**************************************** STEP 3 *********************************************/
	//	Adding synonyms to fitb
	goBackToSelectFitb() {
		this.props.updateMetaCognitiveAnswer(
			this.props.questionBuilder.id,
			{ parts: this.getLatestParts() }
		);
		this.setState((state) => {
			return {
				currentStage: BLANK_SELECTION_STAGE,
				recentAutograderData: { 
					assisting: { selected_content: {1:{content:[this.pageText("textSelectBlank")]}} }
				}
			}
		});
	}

	validateSynonym(synonym) {

		if (!synonym || synonym === "" ) {
			this.setState({
				recentAutograderData: { 
					assisting: { selected_content: {1:{content:[this.errorText("answerShort")]}} }
				} 
			})
			return false
		} else if (synonym.split(' ').length > 3) {
			this.setState({
				recentAutograderData: { 
					assisting: { selected_content: {1:{content:[this.errorText("answerLong")]}} }
				}
			})
			return false
		} else if (_.contains(_.map(_.values(this.state.selectedBlanks), (word) => word.toLowerCase()), synonym.toLowerCase())) {
			this.setState({
				recentAutograderData: { 
					assisting: { selected_content: {1:{content:[this.errorText("repeatingAnswer")]}} }
				}
			})
			return false
		}
		return true
	}

	addSynonym(index) {
		if (index == -1) {
			// NEW SYNONYM
			var newSynonym = this.refs.newSynonym.value
			index = _.size(this.state.synonyms)
		} else {
			var newSynonym = this.refs["synonym-"+index].value
		}
		

		if (this.validateSynonym(newSynonym)) {
			var synonyms = _.clone(this.state.synonyms)
			synonyms[index] = newSynonym
		

			if (_.size(synonyms) < 3) {
				var feedbackContent = this.pageText("addSynonymsMessage")
			} else {
				var feedbackContent = this.pageText("submitQuestionBuilder")
			}
			this.setState({
				unsavedSynonyms: false,
				synonyms,
				recentAutograderData: { 
					assisting: { selected_content: {1:{content:[ feedbackContent ]}} }
				} 
			})
		}
	}

	deleteAnswerOption(index) {
		var synonyms = _.clone(this.state.synonyms)
		delete synonyms[index]
		
		var newSynonyms = {}
		_.each( _.values(synonyms), (synonym,s) => {
			newSynonyms[s] = synonym
		})
		if (_.size(newSynonyms) < 3) {
			var feedbackContent = this.pageText("addSynonymsMessage")
		} else {
			var feedbackContent = this.pageText("submitQuestionBuilder")
		}
		this.setState({
			synonyms,
			recentAutograderData: { 
				assisting: { selected_content: {1:{content:[ feedbackContent ]}} }
			} 
		})
	}

	handleOptionOnKeydown(e) {
		this.setState({ unsavedSynonyms: e.target.value.length > 0 })
	}

	answersDisplay() {
		var answerContent = (
			this.getQuestionBuilderAnswers().map((item, index) => {
				
				return (<div key={index}>
							<input
								className="form-control synonym-input"
								ref={"synonym-"+index}
								defaultValue={item}
							/>
							<LoadingButton
								className="btn-link editButtonStyling"
								text="edit"
								onClick={ this.addSynonym.bind(this, index) }
							/>
							{"|"}
							<LoadingButton
								className="btn-link deleteButtonStyling"
								text="delete"
								onClick={ this.deleteAnswerOption.bind(this, index) }
							/>
						</div>)
			}
		));
		return (
			<div>
				<b>Options:</b>
				{ answerContent }
			</div>
		);
	}

	addAnswersSection() {
		var getExtraAnswers = (this.getQuestionBuilderAnswers().length >= 3) ? ("") :
			(<div key={_.size(this.state.synonyms)}>
				<input
					className="form-control synonym-input"
					ref="newSynonym"
					placeholder="add synonym"
					onKeyUp={(e) => this.handleOptionOnKeydown(e)}
				/>
				<LoadingButton
					className="btn-link doneButtonStyling"
					text="Add"
					onClick={ this.addSynonym.bind(this, -1) }
				/>
			</div>);

		return (
				<div>
					{ this.answersDisplay() }
					{ getExtraAnswers }
				</div>
			);
	}

	confirmReturnHome() {
		if (this.state.unsavedSynonyms) {
			if (confirm("You have unsaved edits that will be lost if you close this window. Make sure to click 'Add' next to each answer option. Still want to submit?")) {
				return true
			} else {
				return false
			}
		} else {
			return true
		}
	}

	returnHome() {

		if (this.confirmReturnHome()) {
			var answerData = {
				draft: false,
				parts: this.getLatestParts()
			};
			this.props.updateMetaCognitiveAnswer(
				this.props.questionBuilder.id,
				answerData
			).then(() => {
				window.wrNotifications.triggerDropDownNotification({
					title: "Fantastic!", text: this.pageText("submitPopUp"), icon: "star"
				});
			});

			if (!this.props.book.text_id || this.props.book.text_id === 'MISSING_TEXT_ID') {
				$wr.redirect(MyShelfRouting.getPath({
					activeView: MyShelfRouting.VIEWS.WORK_VIEW,
					detailsView: "question_builders"
				}));
			} else if (this.props.book && this.props.book.text_id) {
				$wr.redirect(MyShelfRouting.getPath({
					activeView: MyShelfRouting.VIEWS.SHELF_VIEW,
					detailsView: "question_builders",
					textID: this.props.book.text_id
				}));
			} else {
				var redirectPath = "/";
			}
			$wr.redirect(redirectPath)
		}
	}

	renderSubmit() {
		return (
			<div>
				<div className="questionDisplayBox slideLeft">
					<h3>Confirm Your Answers</h3>
					<div>
						<b>Question:</b>
						<p>{ this.getQuestionWithBlank() }</p>
					</div>
					<div>
						<b>Answer:</b>
						<p>{ this.getPartItemText("answer") }</p>
					</div>
					{ this.addAnswersSection() }
					<div className="buttonsBox">
						<LoadingButton
							className="btn buttonPrimary buttonPrimaryLeft"
							text="Back"
							onClick={ this.goBackToSelectFitb.bind(this) }
							loading={ this.state.loading }
						/>
						<LoadingButton
							className="btn buttonPrimary buttonPrimaryRight"
							text="Submit"
							onClick={ this.returnHome.bind(this) }
							loading={ this.state.loading }
						/>
					</div>
				</div>
				<div className="questionFeedbackBox">
					{ this.renderFeedback() }
				</div>
			</div>
		);
	}

	/*************************** Progress Bar *******************************/
	getPhase(finish) {
		switch(this.state.currentStage) {
			case SENTENCE_INPUT_STAGE:
				return 1
			break;
			case BLANK_SELECTION_STAGE:
				return 2
			break;
			case SYNONYM_INPUT_STAGE:
				return 3
			break;
		}
	}

	renderProgressMeter() {
		var iconStems = ["quiz-icons/warmup", "quiz-icons/open-ss", "quiz-icons/open-ss"];

		var studentAvatar = (
			<StudentAvatar student={ CurrentUser.get() } maxWidth={ 45 } disableAnimation={true}/>
		);
		return (
			<StepProgressMeter
				numSteps={ iconStems.length }
				currentStep={ this.getPhase() }
				iconPathStems={ iconStems }
				currentStepDisplay={ studentAvatar }
				finishImgPath="quiz-icons/finish.png"
			/>
		);
	}

	/**************************** AutoSaver *************************************/

	getLatestParts() {
		
		switch (this.state.currentStage) {
			case SENTENCE_INPUT_STAGE:
				var question = this.refs.question.value;
				var parts =  this.updateQuestionParts(question, "question", null)
			break;
			case BLANK_SELECTION_STAGE:
				const answerText = this.handleExcludedPunctuation(_.values(this.state.selectedBlanks).join(" "), 'remove-spaces');
				const index = _.keys(this.state.selectedBlanks)[0]
				if (!_.isEmpty(answerText) && index && !isNaN(index)) {
					var parts = this.updateQuestionParts(answerText, "answer", index)
				}
			break;
			case SYNONYM_INPUT_STAGE:
				// ADD SYNONYMS TO PARTS
				var parts = this.props.questionBuilder.parts
				_.each( this.state.synonyms, (synonym, k) => {
					parts = this.updateQuestionParts(synonym, "synonym-" + k, k)
				})

				// REMOVE SYNONYMS THAT WERE DELETED
				var parts =  _.select(parts, (part) => {
					if (part.type.includes("synonym") && part.index > _.size(this.state.synonyms) - 1) {
						return false
					} else {
						return true
					}
				})
			break;
		}
		return parts
	}
	saveAnswer(draftStatus) {
		
		var answerData = {
			parts: this.getLatestParts(),
			draft: draftStatus
		}
		return this.props.updateMetaCognitiveAnswer(
			this.props.questionBuilder.id,
			answerData
		);
		
	}

	deleteDraft() { 
		this.props.deleteMetaCognitiveAnswer(this.props.questionBuilder.id).then(() => {
			window.wrNotifications.triggerDropDownNotification({
				title: "Your work has been deleted!", text: "", icon: "trash" });
			$wr.redirect("/");
		})
	}

	getAutosaveHash() {
		// if (this.props.questionBuilder) {
		// 	var parts = this.getLatestParts();
		// 	var hashString = _.pluck(parts, "text").join("_");
		// 	var hashValue = $wr.hashCode(hashString);
		// 	return hashValue;
		// } else {
			return "missingQuestionBuilder"
		// }
	}

	autosaveDraft(callback) {
		this.setState({ autosaveLoading: true }, () => {
			this.saveAnswer(this.props.questionBuilder.draft).then(() => {
				this.setState({ autosaveLoading: false });
				if (callback) { callback(); }

			}).catch(() => {
				// Error Handling... allow future autosaving even if this one failed
				this.setState({ autosaveLoading: false });
				if (callback) { callback(); }				
			});
		});
	}

	/**************************** Helpers *************************************/
	textID() {
		if (this.props.book) {
			return this.props.book.text_id;
		} else {
			return $wr.getURLParameterByName("text_id");
		}
	}

	/**************************** RENDER FITB **********************************/

	render() {
		//progressMeterBar at top of page
		var progressMeter = this.renderProgressMeter();

		//Content
		if (this.props.questionBuilder == null) {
			var pageContent = (
				<div><Spinner placeholder={ true } scale={ 1.7 } /></div>
			);
		} else if (this.state.currentStage == SENTENCE_INPUT_STAGE) {
			var pageContent = this.renderQuestionDisplay();
		} else if (this.state.currentStage == BLANK_SELECTION_STAGE) {
			var pageContent = this.renderAnswerBlank();
		} else if (this.state.currentStage == SYNONYM_INPUT_STAGE) {
			var pageContent = this.renderSubmit();
		}

		return (
			<div className="questionBuilderPage clearfix container">
				<header className="pageHeader">
					<h1>Question Builder</h1>
				</header>
				<h3 className="textTitle onQuestionSelect">
					{ this.props.book.title }
				</h3>

				<Autosaver onDeleteClick={ this.deleteDraft } textID={ this.textID() }
					autosaveLoading={ this.state.loading || this.state.autosaveLoading }
					getAutosaveHash={ this.getAutosaveHash } onAutosave={ this.autosaveDraft } />

				{ progressMeter }
				{ pageContent }
			</div>
		);
	}

	// componentDidMount() {
	// 	if (this.textID() != undefined) {
	// 		this.props.populateData();
	// 	}
	// }
};

var EXCLUDED_PUNCTUATION = [',', '.', '!', '?', ';', ')', '(']
var NO_PRECEDING_SPACE = [',', '.', '!', '?', ';', ')']

QuestionBuilderPage.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from @connect
	book: PropTypes.object,
	questionBuilder: PropTypes.object,
	metaQuestion: PropTypes.object,
	currentStage: PropTypes.string,
	// Action hooks from @connect
	populateData: PropTypes.func.isRequired,
	fetchMetaCognitiveQuestion: PropTypes.func,
	createMetaCognitiveAnswer: PropTypes.func,
	updateMetaCognitiveAnswer: PropTypes.func,
	deleteMetaCognitiveAnswer: PropTypes.func,
});

var MAX_ANSWER_AMOUNT = 3;
var ACTIVE_BTN = 1;
var INACTIVE_BTN = 0;

var SENTENCE_INPUT_STAGE = "sentence-input-stage"
var BLANK_SELECTION_STAGE = "blank-selection-stage"
var SYNONYM_INPUT_STAGE = "synonym-input-stage"
 
module.exports = QuestionBuilderPage;


// WEBPACK FOOTER //
// ./modules/components/writing/answers/QuestionBuilderPage.js